export default {
  SET_documents(state, value) {
    state.documents = value;
  },
  SET_document(state, value) {
    state.document = value;
  },
  SET_allDocuments(state, value) {
    state.allDocuments = value;
  },
};
